module.exports = __webpack_public_path__ + "static/img/woocommerce_black.b8170d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/woocommerce_black.png
// module id = q4uY
// module chunks = 1